
import { Options, Vue } from "vue-class-component";
import AudioTrack from "./AudioTrack.vue";
import Visualiser from "./Visualiser.vue";
import Transport from "./Transport.vue";
import Upload from "./Upload.vue";
import Record from "./Record.vue";
import { Watch } from "vue-property-decorator";

@Options({
  props: {},
  components: {
    AudioTrack,
    Visualiser,
    Transport,
    Upload,
    Record
  }
})
export default class Main extends Vue {
  audioContext = new AudioContext();
  trackCount = 1;
  rawBuffer!: AudioBuffer;

  url = "";
  playing = false;
  stop = 0;
  loaded = false;

  colorMap2 = [
    "#D4CDFF",
    "#CEE3FF",
    "#C9FFD9",
    "#FFFECB",
    "#FFCED0",
    "#FFBAE4"
  ];

  colorMap = ["#F400FF", "#6F00EF", "#007FFF", "#77FB00", "#FEFF00", "#FAAB00"];

  @Watch("url")
  loadAudioFile(url: string) {
    const request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.responseType = "arraybuffer";

    request.onload = () => {
      this.audioContext.decodeAudioData(
        request.response,
        buffer => {
          this.rawBuffer = buffer;
          this.loaded = true;
          console.log(this.rawBuffer);
        },
        null
      );
    };
    request.send();
  }

  onPlay() {
    this.playing = this.playing ? false : true;
  }

  onStop() {
    this.playing = false;
    this.stop += 1;
  }

  onTrackAdd() {
    this.trackCount += 1;
  }
}
